module.exports = __webpack_public_path__ + "static/img/egg_r_02.3264a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_02.png
// module id = KQY/
// module chunks = 1